<template>
  <div class="px-3 py-2">
    <v-client-table
      ref="tableComponent"
      :columns="columns"
      :data="dataTable"
      :options="table_options"
      class="jTable"
    >
      <div
        v-if="isAdmin"
        slot="beforeFilter"
        class="custom-search"
      >
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="openModalAdd"
          >
            <i class="fa fa-plus fa-lg"/> Add Index
          </b-button>
        </b-form>
      </div>
      <div
        slot="name"
        slot-scope="props"
      >
        {{ props.row.index_name }}
      </div>
      <div
        slot="definition"
        slot-scope="props"
        class="wrap-definition"
      >
        <div
          v-for="key in props.row.keys"
          :key="key.id"
          class="definition"
        >
          <span>{{ key.column }}</span>
          <img
            :src="require(`@/assets/icon/${key.type === 'ascending' ? 'asc' : 'desc'}.svg`)"
            :alt="key.column.id"
          >
        </div>
      </div>
      <div
        v-if="isAdmin"
        slot="action"
        slot-scope="props"
      >
        <i
          class="fa fa-trash"
          style="font-size: 16px;"
          @click="openModalDelete(props.row.index_name)"
        />
      </div>
    </v-client-table>

    <!-- Modal Add Indexes -->
    <b-modal
      ref="addIndexModal"
      :hide-header="true"
      :hide-footer="true"
      class="modal-indexes"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-add-indexes
        v-if="showModalAdd"
        :columns="listColumns"
        @refresh-data="getDataIndexes"
        @close-modal="closeModalAdd"
      />
    </b-modal>

    <!-- Modal Delete Indexes -->
    <b-modal
      ref="deleteIndexModal"
      :hide-header="true"
      :hide-footer="true"
      class="modal-indexes"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-delete-indexes
        v-if="showModalDelete"
        :indexes-name="indexesSelected"
        @refresh-data="getDataIndexes"
        @close-modal="closeModalDelete"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import modalAddIndexes from '@/views/joanadb/dataset/partials/modalAddIndexes';
import modalDeleteIndexes from '@/views/joanadb/dataset/partials/modalDeleteIndexes';

export default {
  components: {
    modalAddIndexes,
    modalDeleteIndexes,
  },

  data() {
    return {
      dataTable: [],
      listColumns: [],
      showModalAdd: false,
      showModalDelete: false,
      indexesSelected: '',
      columns: ['name', 'definition', 'action'],
      table_options: {
        headings: {
          name: 'Name',
          definition: 'Definition',
          action: '',
        },
        debounce: 1000,
        perPage: 10,
      },
    };
  },

  computed: {
    ...mapState('jStoreJoana', ['dataset_data']),

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },
  },

  created() {
    this.getDataIndexes();
    this.getColumnList();
  },

  methods: {
    ...mapActions('jStoreJoana', ['getIndexes', 'getDetailDatasetByGroup']),

    async getDataIndexes() {
      const id = this.dataset_data.id;
      const res = await this.getIndexes(id);
      if (!res.error) this.dataTable = res.data;
    },

    async getColumnList() {
      const req = {
        id: this.dataset_data.id,
      };
      this.getDetailDatasetByGroup(req).then((res) => {
        const dataDetail = res.data || null;
        if (dataDetail && dataDetail.column) {
          const columnData = Object.values(dataDetail.column);
          this.listColumns = columnData.map(column => ({
            id: column.name,
            text: column.name,
          }));
        }
      });
    },

    openModalAdd() {
      this.showModalAdd = true;
      this.$refs.addIndexModal.show();
    },

    closeModalAdd() {
      this.$refs.addIndexModal.hide();
      setTimeout(() => {
        this.showModalAdd = false;
      }, 400);
    },

    openModalDelete(name) {
      this.indexesSelected = name;
      this.showModalDelete = true;
      this.$refs.deleteIndexModal.show();
    },

    closeModalDelete() {
      this.$refs.deleteIndexModal.hide();
      setTimeout(() => {
        this.indexesSelected = '';
        this.showModalDelete = false;
      }, 400);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-definition {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  .definition {
    width: auto;
    height: 32px;
    padding: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E7E7E7;
    border-radius: 9999px;

    span {
      font-family: 'Poppins-Regular';
      font-size: 14px;
      color: #626262;
      margin-top: 2px;
    }
    img {
      width: 20px;
      height: 20px;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDatasetIndexes.vue